/**
 * Utilities for handling address-related functionality
 */

/**
 * Generates a Google Maps URL from address components
 */
export const getGoogleMapsUrl = (
  address: string,
  addressLine2?: string | null,
  city?: string | null,
  state?: string | null,
  zipCode?: string | null
): string => {
  const addressParts = [];
  if (address) addressParts.push(address);
  if (addressLine2) addressParts.push(addressLine2);
  if (city) addressParts.push(city);
  if (state) addressParts.push(state);
  if (zipCode) addressParts.push(zipCode);

  const fullAddress = addressParts.join(", ");
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
    fullAddress
  )}`;
};
